const path = require('path');

export const getGamePath = function (imagePath) {
  let tempPath;
  let processedPath = imagePath;
  if (/static\/games\//.test(imagePath)) {
    tempPath = imagePath.replace('static/games/', `games/`);
    const isWeb = JSON.parse(process.env.IS_WEB || process.env.VUE_APP_IS_WEB);

    if (!isWeb) {
      processedPath = path.posix.normalize(tempPath);
    } else {
      processedPath = path.normalize(tempPath);
    }
  }
  return processedPath;
};
